import React, { useState, useRef } from "react";
import "./report-download.css";
import { instanceMob } from "../../../../../utils/utils";
import InlineModal from "../../../../info-modal/infoModal";
import "rsuite/dist/rsuite.min.css";
import AlertBox from "../../../../alert-box/alertBox";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { es } from "date-fns/locale";
import { format } from "date-fns";

const customEs = {
  ...es,
  localize: {
    ...es.localize,
    day: (n, opts) => ["D", "L", "M", "X", "J", "V", "S"][n],
    month: (n, opts) => {
      const original = es.localize.month(n, opts);
      return original.charAt(0).toUpperCase() + original.slice(1);
    },
  },
};

const ReportDownload = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalConfig, setModalConfig] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const openModal = (config) => {
    setModalConfig(config);
    setShowModal(true);
  };
  const [range, setRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const cancelBtnRef = useRef(null);

  const closeModal = () => setShowModal(false);

  const handleDownload = () => {
    setIsLoading(true);

    const start = format(range[0].startDate, "dd-MM-yyyy");
    const end = format(range[0].endDate, "dd-MM-yyyy");

    instanceMob
      .get(
        `/admin/metrics/customer/document?start_date=${start}&end_date=${end}`,
        {
          responseType: "blob",
        }
      )
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `reporte-${start}_a_${end}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();

        openModal({
          title: "Descarga completada",
          description:
            "El reporte ha sido descargado correctamente. Puedes encontrarlo en tu carpeta de descargas.",
          secondaryAction: {
            label: "Cerrar",
            onClick: () => {
              cancelBtnRef.current?.click();
              closeModal();
            },
          },
        });
      })
      .catch(() => {
        openModal({
          title: "Error al descargar",
          description:
            "No pudimos generar el reporte. Por favor, verifica tu conexión o intenta más tarde.",
          primaryAction: {
            label: "Reintentar",
            onClick: () => {
              closeModal();
              handleDownload();
            },
          },
          secondaryAction: {
            label: "Cancelar",
            onClick: () => closeModal(),
          },
        });
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <>
      <div className="report-download-container d-flex flex-row justify-content-center align-items-center gap-3 p-2 text-center h-100">
        <h5 className="report-download-title mb-0">
          Descarga el informe general contable de tu Centro Deportivo
        </h5>
        <button
          className="report-download-button-open btn btn-primary"
          data-bs-toggle="modal"
          data-bs-target="#reportDownloadModal"
        >
          Descargar historial <i className="bi bi-download ms-2"></i>
        </button>
      </div>

      <div
        className="modal fade"
        id="reportDownloadModal"
        tabIndex={-1}
        aria-labelledby="reportDownloadModalLabel"
        aria-hidden="true"
      >
        <div className="report-download-modal modal-dialog modal-dialog-centered">
          <div className="modal-content p-4 gap-3 ">
            <AlertBox
              title={"¿Quieres descargar el movimiento de ingresos de tu centro deportivo?"}
              description={
                "Selecciona el rango de fechas para generar un reporte consolidado con toda la información contable del gimnasio durante ese periodo. El informe incluirá el nombre de cada comprador, la fecha y hora de cada transacción, el concepto o servicio adquirido, el medio de pago utilizado y el valor total de cada movimiento. Ideal para análisis financieros, control administrativo o soporte contable."
              }
            />
            <h5 className="report-download-modal-title mb-0">
              Selecciona el periodo o historial
            </h5>

            <DateRange
              editableDateInputs={true}
              onChange={(item) => setRange([item.selection])}
              moveRangeOnFirstSelection={false}
              ranges={range}
              months={2}
              direction="horizontal"
              locale={customEs}
              showDateDisplay={false}
            />

            <div className="d-flex justify-content-end mt-4 gap-4">
              <button
                ref={cancelBtnRef}
                data-bs-dismiss="modal"
                className="report-download-modal-button-cancel btn btn-light"
              >
                Cancelar
              </button>
              <button
                onClick={handleDownload}
                disabled={isLoading}
                className="report-download-modal-button-primary btn btn-light"
              >
                {isLoading ? "Descargando..." : "Descargar"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <InlineModal
          title={modalConfig.title}
          description={modalConfig.description}
          primaryAction={modalConfig.primaryAction}
          secondaryAction={modalConfig.secondaryAction}
        />
      )}
    </>
  );
};

export default ReportDownload;
